import * as Styles from './styles'

const TooltipChart = ({ payload, children }) => {
  if (!children) return null

  return <Styles.Container>{children(payload)}</Styles.Container>
}

export default TooltipChart
